// 산재보험료 환급 계산기 — 페이지 전용 KO/EN 문자열(전역 locale 미오염).
export type IrLang = 'ko' | 'en'

export interface IrStrings {
  metaTitle: string
  metaDesc: string
  badge: string
  heroTitle: string
  heroHighlight: string
  heroSubtitle: string
  calcTitle: string
  industryLabel: string
  industryPlaceholder: string
  workerLabel: string
  workerUnit: string
  wageLabel: string
  wageHint: string
  calcBtn: string
  calculating: string
  // result
  eligibleTitle: string
  eligibleBody: (industry: string) => string
  savingsLead: string
  savingsPerYear: string
  premiumNote: (won: string) => string
  trackRaTitle: string
  trackRaDesc: string
  trackEduTitle: string
  trackEduDesc: string
  won: (n: number) => string
  perYears: (y: number) => string
  // how-to
  howTitle: string
  howSteps: { t: string; d: string }[]
  // trust / criteria
  criteriaTitle: string
  criteriaLead: string
  // cta
  ctaTitle: string
  ctaBody: string
  ctaBtn: string
  ctaSecondary: string
  // faq
  faqTitle: string
  faq: { q: string; a: string }[]
  noticeTitle: string
}

const wonKo = (n: number) => `${Math.round(n).toLocaleString('ko-KR')}원`
const wonEn = (n: number) => `₩${Math.round(n).toLocaleString('en-US')}`

export const IR_I18N: Record<IrLang, IrStrings> = {
  ko: {
    metaTitle: '산재보험료 20% 환급 계산기 | 소규모 사업장 요율제 | Heinrich',
    metaDesc: '제조·임업·위생 50인 미만 사업장이라면 위험성평가 인정으로 산재보험료를 최대 20%(3년) 아낄 수 있습니다. 업종·인원·보수만 입력하면 30초 만에 예상 절감액을 알려드립니다. 무료·회원가입 없이.',
    badge: '소규모 사업장 · 산재예방요율제',
    heroTitle: '산재보험료,',
    heroHighlight: '최대 20% 돌려받으세요',
    heroSubtitle: '제조·임업·위생및유사서비스업 50인 미만 사업장은 위험성평가 인정을 받으면 산재보험료율이 3년간 20% 인하됩니다. 우리 사업장이 얼마나 아낄 수 있는지 30초 만에 확인하세요.',
    calcTitle: '30초 절감액 계산',
    industryLabel: '업종',
    industryPlaceholder: '업종을 선택하세요',
    workerLabel: '상시근로자 수',
    workerUnit: '명',
    wageLabel: '인당 월평균 보수',
    wageHint: '대략적인 1인당 월급여(원). 정확하지 않아도 예상치를 보여드려요.',
    calcBtn: '내 절감액 계산하기',
    calculating: '계산 중…',
    eligibleTitle: '축하합니다 — 20% 할인 대상입니다!',
    eligibleBody: (industry) => `${industry} · 상시근로자 50인 미만 → 산재예방요율제(위험성평가 인정) 대상입니다.`,
    savingsLead: '위험성평가 인정 시 3년간 예상 절감액',
    savingsPerYear: '연간 절감액',
    premiumNote: (won) => `연간 산재보험료 추정 ${won} 기준 · 인정 유지(1년) 시 최대치`,
    trackRaTitle: '위험성평가 인정 (20% · 3년)',
    trackRaDesc: '가장 큰 할인. 우리 AI가 위험성평가서 작성을 도와드립니다.',
    trackEduTitle: '사업주 교육 (10% · 1년)',
    trackEduDesc: '가장 쉬운 첫걸음. 온라인 교육 이수 + 산재예방계획 수립.',
    won: wonKo,
    perYears: (y) => `${y}년`,
    howTitle: '어떻게 받나요? — 3단계면 됩니다',
    howSteps: [
      { t: '1. 대상 확인', d: '지금 이 계산기로 대상 여부와 절감액을 확인합니다.' },
      { t: '2. 위험성평가 인정 준비', d: '가입 후 AI로 위험성평가서를 만들고, 실행(이행) 기록을 쌓습니다. 저희가 단계별로 안내합니다.' },
      { t: '3. 공단에 신청', d: '준비된 서류로 근로복지공단·안전보건공단에 인정을 신청하면 보험료가 인하됩니다.' },
    ],
    criteriaTitle: '인정 심사는 이렇게 봅니다',
    criteriaLead: '실행(이행) 수준이 가장 큰 비중입니다. 꾸준히 안전활동을 기록할수록 유리하며, 저희가 그 기록을 자동으로 쌓아드립니다.',
    ctaTitle: '무료로 준비를 시작하세요',
    ctaBody: '가입하면 우리 사업장에 맞춘 위험성평가서 작성부터 인정 신청 준비까지, 화면이 시키는 대로 따라만 하면 됩니다.',
    ctaBtn: '무료로 준비 시작하기',
    ctaSecondary: '사고사례부터 둘러보기',
    faqTitle: '자주 묻는 질문',
    faq: [
      { q: '정말 돈이 돌아오나요?', a: '산재보험료율이 3년간 인하되어, 그만큼 매년 내는 보험료가 줄어듭니다. 개산·확정보험료 정산 과정에서 환급 형태로 돌아올 수 있습니다. 단, 인하 여부는 공단의 인정 심사 결과에 따릅니다.' },
      { q: '위험성평가가 뭔가요? 어렵지 않나요?', a: '우리 현장에서 다칠 수 있는 위험을 미리 찾아 대책을 적어두는 것입니다. 어려워 보이지만, 저희 AI가 실제 사고사례를 바탕으로 초안을 만들어 드려서 검토·확정만 하시면 됩니다.' },
      { q: '우리 사업장도 대상인가요?', a: '상시근로자 50인 미만이면서 제조업·임업·위생및유사서비스업·하수도업이면 대상입니다. 위 계산기로 바로 확인할 수 있어요.' },
      { q: '얼마나 걸리나요?', a: '위험성평가 작성은 하루면 충분하지만, 인정 심사는 실행(이행) 기록을 봅니다. 보통 몇 개월 꾸준히 안전활동을 기록해두는 것이 유리합니다.' },
    ],
    noticeTitle: '안내',
  },
  en: {
    metaTitle: 'Korea Industrial-Accident Insurance 20% Discount Calculator | Heinrich',
    metaDesc: 'Manufacturing/forestry/sanitation workplaces under 50 workers can cut industrial-accident insurance premiums by up to 20% for 3 years via risk-assessment recognition. Estimate your savings in 30 seconds. Free, no sign-up.',
    badge: 'Small workplaces · Prevention rate program',
    heroTitle: 'Cut your accident-insurance premium by',
    heroHighlight: 'up to 20%',
    heroSubtitle: 'Manufacturing, forestry and sanitation workplaces under 50 workers get a 20% premium-rate cut for 3 years once their risk assessment is recognized. See how much you could save in 30 seconds.',
    calcTitle: '30-second savings estimate',
    industryLabel: 'Industry',
    industryPlaceholder: 'Select your industry',
    workerLabel: 'Number of workers',
    workerUnit: '',
    wageLabel: 'Avg. monthly wage per worker',
    wageHint: 'Approximate monthly wage per worker (KRW). An estimate is fine.',
    calcBtn: 'Calculate my savings',
    calculating: 'Calculating…',
    eligibleTitle: 'Great — you qualify for the 20% cut!',
    eligibleBody: (industry) => `${industry} · under 50 workers → eligible for the prevention-rate program (risk-assessment recognition).`,
    savingsLead: 'Estimated 3-year savings with risk-assessment recognition',
    savingsPerYear: 'Per year',
    premiumNote: (won) => `Based on estimated annual premium of ${won} · max when recognition held for a full year`,
    trackRaTitle: 'Risk-assessment recognition (20% · 3 yrs)',
    trackRaDesc: 'The biggest discount. Our AI helps you write the risk assessment.',
    trackEduTitle: 'Owner education (10% · 1 yr)',
    trackEduDesc: 'The easiest first step. Online course + prevention plan.',
    won: wonEn,
    perYears: (y) => `${y} yrs`,
    howTitle: 'How does it work? — 3 steps',
    howSteps: [
      { t: '1. Check eligibility', d: 'Use this calculator to confirm eligibility and savings.' },
      { t: '2. Prepare recognition', d: 'After sign-up, build your risk assessment with AI and accumulate implementation records. We guide you step by step.' },
      { t: '3. Apply', d: 'Submit the prepared documents to KCOMWEL/KOSHA and your premium rate is reduced.' },
    ],
    criteriaTitle: 'How the review is scored',
    criteriaLead: 'Implementation level carries the most weight. The more consistently you record safety activities, the better — and we accumulate those records automatically.',
    ctaTitle: 'Start preparing for free',
    ctaBody: 'Sign up and just follow the screen — from writing a tailored risk assessment to preparing your recognition application.',
    ctaBtn: 'Start free',
    ctaSecondary: 'Browse accident cases',
    faqTitle: 'FAQ',
    faq: [
      { q: 'Do I really get money back?', a: 'Your premium rate is reduced for 3 years, lowering what you pay each year — which can return as a refund at settlement. Actual reduction depends on the government recognition review.' },
      { q: 'What is a risk assessment? Is it hard?', a: 'It is finding hazards in your workplace and noting controls in advance. Our AI drafts it from real accident cases, so you just review and confirm.' },
      { q: 'Do I qualify?', a: 'If you have under 50 workers and are in manufacturing, forestry, sanitation or sewage, you qualify. Check instantly above.' },
      { q: 'How long does it take?', a: 'Writing the assessment takes a day, but the review looks at implementation records. Consistently logging safety activity over a few months helps.' },
    ],
    noticeTitle: 'Notice',
  },
}
